
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    import { routers } from '@/router/router'
    import Preview from 'vue-photo-preview'
    import ResultModel from '@/store/entities/nationalLogisticsInfo'
    import EditReturnOrder from '@/views/front/abroad/edit-returnorder.vue'
    import 'vue-photo-preview/dist/skin.css'
    import moment from 'moment'
    Vue.use(Preview);


    class PageOrderRequest extends PageRequest {
        //WarehouseOrderStatus?: number ;
        //WarehouseOrderPackageStatus?: number;

        orderStatus?: number;
        packageStatus?: number;
        SearchInfo: string;
        BeginTime?: Date;
        EndTime?: Date;
        OrderType?: number;
        cargoCategory?: number;
        PlatformType?: number;
        site?: number;
        constructor() {
            super();
            this.orderStatus = null;
            this.packageStatus = null;
            this.OrderType = 1;
            //this.PlatformType = 0;
        }
    }


    @Component({
        name: "mainlandorderlist",
        components: { EditReturnOrder }
    })
    export default class Orders extends AbpBase {
        pagerequest: PageOrderRequest = new PageOrderRequest();
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        cargoCategoryType = Enums.getEnum(Enums.CargoCategoryType, true);
        siteType = Enums.getEnum(Enums.SiteSType, true);
        orderStatus = Enums.getEnum(Enums.WarehouseOrderStatus, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        packageStatus = Enums.getEnum(Enums.WarehouseOrderPackageStatus, true);
        Model: ResultModel = null;
        spinShow: boolean = false;
        editreturnorderModel: boolean = false;
        get list() {
            return this.$store.state.fontmainlandorder.list;
        };
        get loading() {
            return this.$store.state.fontmainlandorder.loading;
        }
        pageChange(page: number) {
            this.$store.commit('fontmainlandorder/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('fontmainlandorder/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.fontmainlandorder.currentPage=1;
            this.getpage();
        }
        async exportexpress() {
            await this.$store.dispatch({
                type: 'fontmainlandorder/impotExcel',
                data: this.pagerequest
            })
        }
        async handleRowClick(row) {
            var _this = this;
            if (row.waybillNumber != null) {
                this.spinShow = true;
                this.Model =  await this.$store.dispatch({
                    type: 'fontmainlandorder/getResult',
                    data: { number: row.waybillNumber }
                }).finally(() => {
                //    setTimeout(() => {
                //    this.spinShow = false;
                //}, 1000);
                    this.spinShow = false;
                });
                var a = this.Model;
                if (this.Model == null) {
                    this.$Modal.info({
                        title: "提示", content: "没有跟踪信息！", onOk: async () => {
                        }
                    });
                }

                else {
                    if (this.Model.itemInfo != null) {
                        var html = "";
                        var tr = "";
                        var table = "<table style='border:1px solid #0094ff;border-collapse:collapse; cellpadding:2;cellspacing:0;'><tr><td style='border:1px solid #0094ff;'>日期时间</td><td style='border:1px solid #0094ff;'>服务地点</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;详细内容</td></tr>";
                        this.Model.itemInfo.forEach(function (item, index) {
                            tr += "<tr><td style='border:1px solid #0094ff;'>" + item.dateTime + "&#12288;&#12288;</td><td style='border:1px solid #0094ff;'>" + item.serviceSite + "</td><td style='border:1px solid #0094ff;'>&#12288;&#12288;" + item.content +"</td></tr>";
                        })
                        var endtable = "</table>";
                        html = table + tr + endtable;
                        this.$Modal.info({
                            title: "提示", width:800, content: "货运单号：" + this.Model.waybillNumber + "<br />" + "出发地：" + this.Model.leavePlace + " <br />" + "目的地：" + this.Model.purposePlace + " <br /> " + "状态：" + this.Model.status + "<br /><br />" + html, onOk: async () => {
                            }
                        });
                    }
                    else {
                        this.$Modal.info({
                            title: "提示", content: "货运单号：" + this.Model.waybillNumber + "<br />" + "出发地：" + this.Model.leavePlace + " <br />" + "目的地：" + this.Model.purposePlace + " <br /> " + "状态：" + this.Model.status, onOk: async () => {
                            }
                        });
                    }
                  
                }
                
                
              
            };
         
            
        }
        async InputReturnOrder(data: any) {
            this.$store.state.fontoverseasreturnorders.id = data.id;
            this.$store.state.fontoverseasreturnorders.orderNumber = data.orderNumber;
            this.editreturnorderModel = true;
        }
        async getpage() {
            if (this.creationTime.length > 0) {
                this.pagerequest.BeginTime = this.creationTime[0];
            } else {
                this.pagerequest.BeginTime = null;
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.EndTime = this.creationTime[1];
            } else {
                this.pagerequest.EndTime = null;
            }
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

            await this.$store.dispatch({
                type: 'fontmainlandorder/getAll',
                data: this.pagerequest
            });

            var _this: any = this;
            _this.$previewRefresh();
        }
        get pageSize() {
            return this.$store.state.fontmainlandorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.fontmainlandorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.fontmainlandorder.currentPage;
        }
        async operationData(name: any, data: any) {
             if (name == '撤销') {
                await this.$store.dispatch({
                    type: 'fontmainlandorder/cancelOrder',
                    data: { id: data.id }
                });
                this.getpage();
            } else if (name == '查看详情') {
                await this.$store.dispatch({
                    type: 'fontmainlandorder/getOrder',
                    data: { id: data.id }
                });
                 this.$store.state.fontmainlandorder.orderStatus = data.orderStatus;
                 this.$router.push({ name: 'frontmainlandorderDetail' });
            } else if (name == '补充运费') {
                await this.$store.dispatch({
                    type: 'fontmainlandorder/supplyFreight',
                    data: { id: data.id }
                });
                 this.$store.state.fontmainlandorder.orderStatus = data.orderStatus;
                this.getpage(); 
            }
             else if (name == '标记为正常') {
                 await this.$store.dispatch({
                     type: 'fontorder/normalOrder',
                     data: { id: data.id }
                 });
                 this.getpage();
             }
        }

        columns = [
            {
                title: '仓库名称',
                key: 'warehouseName',
                width: 150,
            }, {
                title: '订单编号',
                key: 'orderNumber',
                width: 150,
                fixed: 'left',
            }, {
                title: '订单状态',
                width: 150,
                key: 'orderStatus',
                render: (h: any, params: any) => {
                    var warehouseNote = params.row.warehouseNote;
                    if (warehouseNote) {
                        warehouseNote = "(" + warehouseNote + ")";
                    }
                    else {
                        warehouseNote = "";
                    }
                    return h('div', [h('p', Enums.WarehouseOrderStatus.filter(function (item) { return item.value == params.row.orderStatus })[0].name), [h('p', { style: { color: 'red' } }, warehouseNote)]]
                    )
                }
            }, {
                title: '货物类别',
                width: 90,
                key: 'cargoCategory',
                render: (h: any, params: any) => {
                    return h('span', Enums.CargoCategoryType.filter(function (item) { return item.value == params.row.cargoCategory })[0].name);
                }
            },
            {
                title: '店铺站点',
                width: 90,
                key: 'site',
                render: (h: any, params: any) => {
                    return h('span', Enums.SiteSType.filter(function (item) { return item.value == params.row.site })[0].name);
                }
            }, {
                title: '包裹状态',
                width: 120, 
                key: 'packageStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name);
                }
            },
            {
                title: '错误信息',
                key: 'mistakeinfomation',
                width: 150,
                 render: (h: any, params: any) => {
                     return h('div', [h('span', { style: { color: 'red' } }, params.row.mistakeinfomation)]
                    )
                }
            },
            {
                title: '退件订单编号',
                width: 120,
                key: 'returnNumber',
            },
            {
                title: '货运单号',
                key: 'waybillNumber',
                width: 120,
            },
            {
                title: '称重信息',
                key: 'logistics',
                width: 450,
                //  fixed: 'left',
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map((item, index) => {
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var color = PackageStatus.color;

                        if (item.isReject || item.isReturn || packagestus == "已撤销") {
                            color = "#ff0000";
                        }

                        // 构建显示内容
                        var shipment = item.shipment || '';
                        var shelfNumber = item.shelfNumber ? '-' + item.shelfNumber : '';
                        var count = item.orderCount > 1 ? "【" + item.orderCount + "】" : '';

                        // 尺寸重量信息 - 合并到一行
                        var sizeInfo = '';
                        if (item.long && item.wide && item.high) {
                            sizeInfo = `${item.long}*${item.wide}*${item.high}cm`;
                        }

                        var weightInfo = item.weight ? `${item.weight}g` : '';
                        var bulkyInfo = item.bulkyByClient ? `体积:${item.bulkyByClient}g` : '';
                        var finalWeight = item.heavyWeight ? `实重:${item.heavyWeight}g` : '';
                        var freightInfo = item.freightCost ? `积分:${item.freightCost}` : '';

                        // 是否付费
                        var deductionText = item.isDeduction !== undefined ? (item.isDeduction ? '已付费' : '未付费') : '';

                        // 第二行合并所有信息
                        var secondLineInfo = [
                            sizeInfo,
                            weightInfo,
                            bulkyInfo,
                            finalWeight,
                            freightInfo,
                            deductionText
                        ].filter(function (info) { return info && info !== ''; }).join(' | ');

                        return h('li', {
                            style: {
                                border: '1px solid #e8eaec',
                                margin: '5px 0',
                                padding: '8px',
                                borderRadius: '4px',
                                backgroundColor: color ? '#f8f8f9' : 'transparent'
                            }
                        }, [
                            h('div', {
                                style: {
                                    borderLeft: color ? `5px solid ${color}` : 'none',
                                    paddingLeft: '5px'
                                }
                            }, [
                                // 第一行：快递单号和基础信息
                                h('div', {
                                    style: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        marginBottom: '5px'
                                    }
                                }, [
                                    h('span', {
                                        style: { fontWeight: 'bold', marginRight: '5px' }
                                    }, '快递单号：'),
                                    h('span', {
                                        style: { color: '#1890ff', marginRight: '10px' }
                                    }, shipment),

                                    deductionText ? h('span', {
                                        style: {
                                            marginRight: '10px',
                                            padding: '2px 8px',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            background: item.isDeduction ? '#52c41a' : '#ff4d4f',
                                            color: 'white'
                                        }
                                    }, deductionText) : null,

                                    count ? h('span', {
                                        style: { color: '#f5222d', marginRight: '10px' }
                                    }, count) : null,

                                    shelfNumber ? h('span', {
                                        style: {
                                            background: '#f5f5f5',
                                            padding: '2px 6px',
                                            borderRadius: '4px'
                                        }
                                    }, shelfNumber) : null,

                                    item.weightImageUploadGuid ? h('img', {
                                        style: {
                                            width: '30px',
                                            height: '30px',
                                            marginLeft: '5px',
                                            verticalAlign: 'middle',
                                            borderRadius: '4px',
                                            border: '1px solid #d9d9d9',
                                            cursor: 'pointer'
                                        },
                                        attrs: {
                                            src: this.getImageUrl(item.weightImageUploadGuid),
                                            preview: params.row.id + '-' + index,
                                            "preview-text": item.shipment + '称重图片'
                                        }
                                    }) : null
                                ]),

                                // 第二行：尺寸重量等信息（合并为一行）
                                secondLineInfo ? h('div', {
                                    style: {
                                        fontSize: '12px',
                                        color: '#666',
                                        marginTop: '3px'
                                    }
                                }, secondLineInfo) : null,

                                // 称重时间单独一行（如果需要显示）
                                item.weighingTime ? h('div', {
                                    style: {
                                        marginTop: '3px',
                                        fontSize: '12px',
                                        color: '#999'
                                    }
                                }, '称重时间：' + DateUtils.formatLongDate(new Date(item.weighingTime))) : null
                            ])
                        ]);
                    }));
                }
            },{
                title: '异常图片',
                key: 'abnormalImageUploadGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.abnormalImageUploadGuid) {
                        var data = { imageGuid: params.row.abnormalImageUploadGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "100px",
                                height: "100px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id,
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },{
                title: '创建时间',
                key: 'createTime',
                width: 100,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
                }
            },
            {
                title: '送仓时间',
                key: 'arriveWarehouseTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.arriveWarehouseTime ? DateUtils.formatLongDate(new Date(params.row.arriveWarehouseTime)) : '');
                }
            }, {
                title: '快递单号',
                key: 'logistics',
                width: 200,
                render: (h: any, params: any) => {
                    return h('ul', params.row.logistics.map(item => {

                        var productOrderStatusName = "";
                        if (params.row.productOrderStatus != null) {
                            productOrderStatusName = Enums.ProductOrderStatus.filter(function (dataItem) { return dataItem.value == params.row.productOrderStatus })[0].name;
                        }
                        var packagestus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
                        var PackageStatus = Enums.ShipmentReceiveStatus.filter(function (dataItem) { return dataItem.value == item.receiveStatus })[0];
                        var shipment = '';
                        var shelfNumber = '';
                        var color = PackageStatus.color;
                        if (item.isReject || item.isReturn || productOrderStatusName == "已取消" || packagestus=="已撤销") {
                            color = "#ff0000";
                        }
                        var count = '';
                        if (item.shipment) {
                            shipment = item.shipment;
                        }
                        if (item.orderCount > 1) {
                            count = "【" + item.orderCount + "】";
                            //shipment = item.shipment + "【" + item.orderCount + "】";
                        }
                        if (item.shelfNumber) {
                            shelfNumber = "-" + item.shelfNumber + "";
                            //shipment = shipment + "-" + item.shelfNumber;
                        }
                        return h('li', {
                            domProps: {
                                innerHTML: '<a title="' + PackageStatus.name + '" href="#" style="' + ((color && color.length) > 0 ? "border-left:5px solid " + color + ";padding-left:5px" : "") + '">' + shipment + '<span style="color:red;">' + count + '</span>' + shelfNumber + '</a>'
                            }
                        });

                    }));
                }
            },
            {
                title: '商品信息',
                width: 600,
                key: 'orderProductInfoList',
                render: (h: any, params: any) => {
                    var _this = this;
                    return h('ul', params.row.orderProductInfoList.map(item => {
                        var img = item.url ? '<img src="' + item.url + '" alt="' + item.productName + '" class="img"  onclick="handleChangeImg()" >' : "";
                        return h('li', {
                        }, [
                            h('img', {
                                attrs: {
                                    class: "img",
                                    src: item.url,
                                    preview: params.row.id,
                                    "preview-text": params.row.orderNumber + "-" + item.productName
                                }
                            }), item.productName, h('font', { style: { color: "red" } }, '*'), h('h2', { style: { color: "red", display: "inline-block" } }, item.count)]);
                    }));
                }
            }, {
                title: '本土包裹名称',
                key: 'packageName',
                width: 200,
                render: (h: any, params: any) => {
                    // 为每一行创建独立的防抖函数
                    let debounceTimer: any = null;
                    const rowId = params.row.id;

                    return h('span', {
                        style: {
                            color: '#1890ff',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        },
                        on: {
                            dblclick: async () => {
                                const orderId = params.row.id;
                                const trackingNumber = params.row.packageName;3

                                if (!trackingNumber) {
                                    this.$Message.warning('没有可查询的物流单号');
                                    return;
                                }
                                this.debouncedQueryTrack(orderId, trackingNumber);
                            }
                        }
                    }, params.row.packageName);
                }
            },
            {
                title: '运费',
                key: 'freightCost',
                //className: this.Dispaly,
                width: 150,
                render: (h: any, params: any) => {
                    //var _this = this;
                    //if (params.row.packageStatus == 2) {
                    //    _this.Dispaly = "demo-table-info-column";
                    //}
                    return h('span', params.row.freightCost == 0 ? "" : params.row.freightCost)
                }
            }, {
                title: '是否支付',
                key: 'isPay',
                width: 120,
                render: (h: any, params: any) => {
                    return h('span', params.row.isPay ? this.L('是') : this.L('否'))
                }
            },
            {
                title: '备注',
                width: 200,
                key: 'reMark',
            }, {
                title: '打包袋数量',
                key: 'sackNums',
                width: 80,
            },
            {
                title: '基本SKU数量',
                key: 'baseSkuNums',
                width: 80,
            },
            {
                title: '打包袋金额',
                key: 'sackTotalAmount',
                width: 80,
            },
            {
                title: 'SKU金额',
                key: 'skuTotalAmount',
                width: 80,
            }, {
                title: '操作',
                width: 120,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var _this = this;
                    var menu = [];
                    var data = params.row;
                    if (params.row.packageStatus == 0 && params.row.orderStatus == 0 || params.row.orderStatus == -1) {
                        menu.push("撤销");
                    } if (params.row.packageStatus == 7 && params.row.orderStatus == 0) {
                        menu.push("补充运费");
                    }
                    if (params.row.orderStatus == -1) {
                        menu.push("标记为正常");
                    }
                    menu.push("查看详情");
                     return h('div', [
                        h('Dropdown', {
                            props: {
                                transfer: true,
                                trigger: 'click',
                            },
                            on: {
                                'on-click': (name) => {
                                    _this.operationData(name, params.row);
                                }
                            }

                        }, [
                            h('Button',
                                {
                                    domProps: {
                                        innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                                    },
                                    props: {
                                        type: 'primary',
                                    },
                                    style: {
                                        marginTop: '5px',
                                        height: '30px',
                                        width: '85px',
                                    },

                                }),
                            h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                                return h('DropdownItem', { props: { name: item } }, item)
                            })
                            )]),
                         h('Button', {
                             props: {
                                 type: 'primary',
                                 size: 'small',
                             },
                             style: {
                                 marginTop: '5px',
                                 height: '30px',
                                 width: '85px',
                                 display: (data.packageStatus == 4 && data.orderStatus == 0) ? "inline-block" : "none",
                             },
                             on: {
                                 click: () => {
                                     this.InputReturnOrder(data);

                                 }
                             }

                         }, "编辑退件订单"),
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                height: '30px',
                                width: '85px',
                            },
                            on: {
                                click: () => {
                                    var data = params.row;
                                    if (params.row.pdfGuid && params.row.pdfGuid.length > 1) {
                                        this.$store.commit('fontorder/getPdf', {
                                            pdfGuid: data.pdfGuid,
                                            orderNumber: data.orderNumber
                                        });
                                    }
                                }
                            }

                        }, "查看PDF"),
                       
                    ]);
                }
            }]


        getImageUrl(guid: string) {
            if (!guid) return '';
            var data = { imageGuid: guid, url: null };
            this.$store.commit('backlogistics/getImgUrl', data);
            return data.url;
        }


        // 在类中添加防抖存储
        debounceTimers: Map<number, any> = new Map();

        // 防抖查询方法 - 无loading版本
        debouncedQueryTrack(orderId: number, trackingNumber: string) {
            // 清除该订单的现有定时器
            if (this.debounceTimers.has(orderId)) {
                clearTimeout(this.debounceTimers.get(orderId));
            }

            // 设置新的定时器
            const timer = setTimeout(async () => {
                // 调用轨迹查询接口
                const trackList = await this.$store.dispatch('backmainlandorder/getLogisticsTrack', {
                    orderId: orderId,
                    number: trackingNumber
                });

                if (trackList && trackList.length > 0) {
                    // 格式化轨迹信息，只显示时间和步骤
                    const trackHtml = this.formatTrackInfo(trackList);

                    this.$Modal.info({
                        title: '物流轨迹 - ' + trackingNumber,
                        width: 600,
                        content: trackHtml,
                        okText: '关闭'
                    });
                } else {
                    this.$Modal.info({
                        title: '物流轨迹',
                        content: '暂无轨迹信息'
                    });
                }

                // 清除定时器记录
                this.debounceTimers.delete(orderId);
            }, 300);

            // 存储定时器
            this.debounceTimers.set(orderId, timer);
        }

        /**
 * 格式化轨迹信息，只显示时间和步骤
 */
        formatTrackInfo(trackList: any[]): string {
            if (!trackList || trackList.length === 0) {
                return '<p>暂无轨迹信息</p>';
            }

            // 按时间倒序排序（最新的在前面）
            const sortedList = [...trackList].sort((a, b) => {
                const timeA = a.statusTime ? new Date(a.statusTime).getTime() : 0;
                const timeB = b.statusTime ? new Date(b.statusTime).getTime() : 0;
                return timeB - timeA;
            });

            let html = '<div style="max-height: 400px; overflow-y: auto;">';
            html += '<table style="width: 100%; border-collapse: collapse;">';
            html += '<thead><tr style="background-color: #f5f7f9;">';
            html += '<th style="padding: 10px; border: 1px solid #e8eaec; text-align: left;">时间</th>';
            html += '<th style="padding: 10px; border: 1px solid #e8eaec; text-align: left;">物流状态</th>';
            html += '</tr></thead>';
            html += '<tbody>';

            sortedList.forEach((item, index) => {
                const statusTime = item.statusTime ? this.formatDateTime(item.statusTime) : '';
                const statusName = item.statusName || '未知状态';
                const backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafafa';

                html += `<tr style="background-color: ${backgroundColor};">`;
                html += `<td style="padding: 8px; border: 1px solid #e8eaec;">${statusTime}</td>`;
                html += `<td style="padding: 8px; border: 1px solid #e8eaec;">${statusName}</td>`;
                html += '</tr>';
            });

            html += '</tbody></table>';
            html += '</div>';

            return html;
        }

        /**
         * 格式化日期时间
         */
        formatDateTime(dateStr: string): string {
            if (!dateStr) return '';

            try {
                const date = new Date(dateStr);
                if (isNaN(date.getTime())) return dateStr;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch {
                return dateStr;
            }
        }


        async created() {
            var abnormal = abp.getQueryVariable("abnormal");
            if (abnormal && abnormal == 'true') {
                this.pagerequest.orderStatus = -1;
            }
            this.getpage();
        }
    }
